/**
 * AiBusyOverlay — Dogfood-fix-wave-1 F8
 *
 * Invisible global component. When any AI/LLM-backed mutation is in flight
 * (aiBusy.count > 0), sets document.body.style.cursor = 'wait' to signal
 * the user that background AI work is happening.
 *
 * Mount ONCE inside RorosSidebarLayout so it covers all ROROS pages.
 * No DOM output — purely a side-effect component.
 */

import { useEffect } from 'react';
import { useAiBusyStore } from '@/lib/aiBusy';

export function AiBusyOverlay() {
  const count = useAiBusyStore((s) => s.count);

  useEffect(() => {
    if (count > 0) {
      document.body.style.cursor = 'wait';
    } else {
      document.body.style.cursor = '';
    }
    // Cleanup: always restore cursor on unmount
    return () => {
      document.body.style.cursor = '';
    };
  }, [count]);

  // No DOM output
  return null;
}
